<template>
  <div class="mx-4">
    <div class="row mb-3 pt-3">
      <div class="col-12">
        <icon-view
          icon="fa fa-plus-circle"
          icon-background="#fff"
          icon-color="#FF7058"
          icon-size="16px"
          title="Pago Adicional"
          variant="custom-icon-view"
        />
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <validation-provider
          v-slot="{ errors }"
          rules="required|differentFromZero|greaterThanZero"
        >
          <custom-input
            v-model="model.amount"
            class="payment-amount"
            custom-error-msg=""
            :error="errors[0]"
            label="Pago adicional:"
            mask-type="Money"
            prepend-icon="fa fa-dollar-sign"
            :prepend-icon-left="true"
            prepend-icon-type="success"
          />
          <custom-error
            v-if="errors[0]"
            :message="errors[0]"
            variant="no-border mb-3"
          />
        </validation-provider>
      </div>
      <div class="col-12 mt-3">
        <validation-provider v-slot="{ errors }" rules="required">
          <custom-text-area
            v-model="model.comment"
            custom-error-msg="Debe completar campo."
            :error="errors[0]"
            label="Comentario:"
            :maxlength="500"
            show-char-count
          />
        </validation-provider>
      </div>
    </div>
    <div class="row mt-3 mt-md-0 mt-sm-3 pb-3">
      <div
        class="col-12 d-flex align-items-center justify-content-md-end justify-content-sm-none"
      >
        <action-button
          i="fas fa-times-circle"
          variant="outline-danger btn-cancel danger px-3 mr-2"
          @click="onCancel()"
        >
          Cancelar
        </action-button>
        <action-button
          i="fas fa-check"
          variant="success px-3"
          @click="onConfirm()"
        >
          Confirmar
        </action-button>
      </div>
    </div>
  </div>
</template>

<script>
import { ValidationProvider } from 'vee-validate';
import IconView from 'icon-view';
import CustomInput from 'CustomInput';
import CustomTextArea from 'CustomTextArea';
import ActionButton from 'ActionButton';
import CustomError from 'custom-error';

export default {
  name: 'AdditionalPayment',
  components: {
    ValidationProvider,
    IconView,
    CustomInput,
    CustomTextArea,
    ActionButton,
    CustomError,
  },
  data: () => ({
    model: {
      amount: null,
      comment: null,
    },
  }),
  methods: {
    onCancel() {
      this.$emit('on-cancel');
    },
    onConfirm() {
      this.$emit('on-confirm', this.model);
    },
  },
};
</script>

<style scoped lang="scss">
.payment-amount {
  max-width: 200px;
}

@media only screen and (max-width: 768px) {
  .payment-amount {
    max-width: 70%;
  }
}
</style>
